export const sources={avif:"__VITE_ASSET__YJve1ATl__ 24w"};export const img={src:"__VITE_ASSET__C2KBnq80__",w:24,h:24};export default{sources:sources,img:img};